import React from "react";
import { useEffect, useState } from "react";

import {
  Typography,
  Paper,
  Box,
  Button,
  // Stack,
  // Tooltip,
  IconButton,
  // Modal,
} from "@mui/material";
// import { Link as RouterLink } from "react-router-dom";

import {
  FinanceData,
  FinanceDataValues,
  // Expense,
  // ExtraIncome,
  // ErrorCheck,
} from "../types";

// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";

// import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";
// import { Console, error } from "console";
// import { Label } from "@mui/icons-material";
// import HomeChart from "../components/HomeChart";
import TotalsCards from "../components/TotalsCards";
import ExpenseBreakdown from "../components/ExpensesBreakdown";
// import SkipToMain from "../components/SkipToMain";

import { getCurrentDailyBudget } from "../utils/moneyFunctions";
import MainInfoUpdateModal from "../components/modals/MainInfoUpdateModal";
import FinanceDataImportModal from "../components/modals/ImportFinanceDataModal";

// import ReportTransactionsList from "../components/reports/ReportTransactionsList";
import HomeTitleCard from "../components/home/HomeTitleCard";

import CardReferenceTag from "../components/common/CardReferenceTag";

// import { basicGreenVariable } from "../utils/appStyles";

const Home: React.FC = () => {
  const defaultCategories = [
    "Mandatory / Bills",
    "Unexpected Expenses",
    "Investment",
    "Luxury",
    "Study",
    "Coffee",
    "Grocery",
    "Other",
  ];

  const [newExpense, setNewExpense] = useState({
    amount: 0,
    category: "",
    customCategory: "",
  });

  const [newExtraIncome, setNewExtraIncome] = useState({
    amount: 0,
    description: "",
    // id: string
    // description: string
    // amount: number
    // date: string
  });

  const [estimatedMandatoryExpenses, setEstimatedMandatoryExpenses] =
    useState<number>(0);

  const [loading, setLoading] = useState<boolean>(true);
  console.log('loading',loading)
  const [editing, setEditing] = useState<string>("");
  const [financeData, setFinanceData] = useState<FinanceData>({
    expectedIncome: 0,
    expectedSavings: 0,
    title: "",
    description: "",
    expenses: [],
    extraIncome: [],
    notes: "",
    startDate: new Date(),
    endDate: new Date(),
  });

  useEffect(() => {
    const loadFinanceData = async () => {
      try {
        const storedData = localStorage.getItem("financeData");
        if (storedData) {
          setFinanceData(JSON.parse(storedData));
        }
      } catch (error) {
        console.error("Error loading finance data:", error);
      } finally {
        setLoading(false);
      }
    };

    // Call the async function
    loadFinanceData();
  }, []);

  const exportFinanceDataToFile = (): void => {
    // Step 1: Get the data from localStorage
    const data = localStorage.getItem("financeData");

    if (!data) {
      console.error(`No data found for Finance Data`);
      return;
    }

    // Step 2: Create a Blob object from the data (convert to a JSON Blob)
    const blob = new Blob([data], { type: "application/json" });

    // Step 3: Create a link element to trigger the download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `FinanceDataBackup.json`; // File will be downloaded as filename.json

    // Step 4: Trigger the download by programmatically clicking the link
    link.click();

    // Cleanup the URL object
    URL.revokeObjectURL(link.href);
  };

  const updateFinancialData = (item: string, value: FinanceDataValues) => {
    const updatedData: FinanceData = { ...financeData };
    updatedData[`${item}`] = value as FinanceDataValues;
    setFinanceData(() => ({ ...financeData, [`${item}`]: value }));
    localStorage.setItem("financeData", JSON.stringify(updatedData));
  };

  const resetFinanceData = () => {
    setFinanceData({
      expectedIncome: 0,
      expectedSavings: 0,
      title: "",
      description: "",
      expenses: [],
      extraIncome: [],
      notes: "",
      startDate: new Date(),
      endDate: new Date(),
    });
    saveFinanceData({
      expectedIncome: 0,
      expectedSavings: 0,
      title: "",
      description: "",
      expenses: [],
      extraIncome: [],
      notes: "",
      startDate: new Date(),
      endDate: new Date(),
    });
  };

  const addExpense = () => {
    if (
      newExpense.amount > 0 &&
      ((newExpense.category !== "" && newExpense.category !== "Other") ||
        (newExpense.customCategory !== "" && newExpense.category === "Other"))
    ) {
      setFinanceData((prev) => ({
        ...prev,
        expenses: [
          ...prev.expenses,
          {
            id: Date.now().toString(),
            amount: newExpense.amount,
            category:
              newExpense.category === "Other"
                ? newExpense.customCategory
                : newExpense.category,
            date: new Date().toISOString(),
          },
        ],
      }));
      setNewExpense({ amount: 0, category: "", customCategory: "" });
      saveFinanceData({
        ...financeData,
        expenses: [
          ...financeData.expenses,
          {
            id: Date.now().toString(),
            amount: newExpense.amount,
            category:
              newExpense.category === "Other"
                ? newExpense.customCategory
                : newExpense.category,
            date: new Date().toISOString(),
          },
        ],
      });
    }
  };

  const addExtraIncome = () => {
    if (newExtraIncome.amount > 0 && newExtraIncome.description !== "") {
      setFinanceData((prev) => ({
        ...prev,
        extraIncome: [
          ...prev.extraIncome,
          {
            id: Date.now().toString(),
            amount: newExtraIncome.amount,
            description: newExtraIncome.description,
            date: new Date().toISOString(),
          },
        ],
      }));
      setNewExtraIncome({ amount: 0, description: "" });
      saveFinanceData({
        ...financeData,
        extraIncome: [
          ...financeData.extraIncome,
          {
            id: Date.now().toString(),
            amount: newExtraIncome.amount,
            description: newExtraIncome.description,
            date: new Date().toISOString(),
          },
        ],
      });
    }
  };

  const saveFinanceData = (data: FinanceData) => {
    localStorage.setItem("financeData", JSON.stringify(data));
  };

  const formatDateToString = (date: Date) => {
    return new Date(date)
      .toLocaleString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(":", "");
  };

  const isValidDate = (value: any): boolean => {
    const date = new Date(value);
    return !isNaN(date.getTime());
  };

  // const checkForTimeTravel = (startDate: Date, endDate: Date) => {
  //   let errorMessage = "";

  //   if (!isValidDate(startDate) || !isValidDate(endDate)) {
  //     errorMessage = "Please select a valid date";
  //   }
  //   if (errorMessage !== "" || new Date(startDate) > new Date(endDate)) {
  //     errorMessage = "Time Travel can prevent certain function from working";
  //   }

  //   return {
  //     error: errorMessage !== "",
  //     message: errorMessage,
  //   };
  // };

  // const timeTravelCheck = checkForTimeTravel(
  //   financeData.startDate,
  //   financeData.endDate
  // );

  const dailyBudget =
    financeData.startDate &&
    financeData.endDate &&
    financeData.expectedIncome &&
    financeData.expectedSavings
      ? getCurrentDailyBudget(
          financeData.expectedIncome,
          estimatedMandatoryExpenses,
          financeData.expectedSavings,
          financeData
        )
      : "0";

  return (
    <>
      <main id={"home-main"} style={{padding:'20px',maxWidth:'1400px',marginLeft:'auto',marginRight:'auto'}}>
        <Box>
          <Typography>
            <strong>Welcome</strong> to Financetracker.App, set a time range,
            savings budget, expected income and other informations. Just make
            sure to export / import a backup when moving from one computer to
            another. Something truly unexpected came about? add a note.
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              paddingBlock: 3,
              gap: 2,
            }}
          >
            <button onClick={() => setEditing("import")}>Import Data</button>
            <button onClick={exportFinanceDataToFile}>Export Data</button>
            <button onClick={resetFinanceData}>clear it all</button>
          </Box>

          <Box id="pdf-section">
            <Box
              sx={{
                display: { sm: "grid", xs: "flex" },
                flexDirection: "column",
                gridTemplateColumns: {
                  sm: "repeat(2, 1fr)",
                  md: "repeat(4, 1fr)",
                },
                gap: 2,
                mt: 2,
              }}
            >
              {/* Box 1................................................................................................. */}
              <Paper
                elevation={2}
                sx={{
                  gridColumn: "span 2",
                  padding: 2,
                  p: 2,
                  textAlign: "left",
                }}
              >
                <HomeTitleCard
                  title={
                    financeData?.title !== ""
                      ? financeData.title
                      : "Finance Notes"
                  }
                  description={
                    financeData?.description !== ""
                      ? financeData.description
                      : "Finance Tracking for a more healthy relationship with money"
                  }
                  startDate={formatDateToString(financeData.startDate)}
                  endDate={formatDateToString(financeData.endDate)}
                />
                <Box
                  sx={{
                    mt: 1,
                    textAlign: "right",
                  }}
                >
                  <IconButton
                    size="small"
                    onClick={() => {
                      setEditing(editing !== "date" ? "date" : "");
                    }}
                    aria-label="Date Edit Button"
                  >
                    <ModeEditOutlineIcon fontSize={"small"} />
                  </IconButton>
                </Box>
              </Paper>
              {/* Box 2................................................................................................. */}
              <Paper
                elevation={2}
                sx={{
                  gridColumn: "span 1",
                  p: 2,
                  textAlign: "left",
                }}
              >
                <CardReferenceTag
                  color="blue"
                  tooltip="Add the initial expected income and amount of savings for the defined period"
                />
                <Box>
                  <Typography sx={{ mt: 1 }} variant="h5">
                    <strong>Basic Income Info</strong>
                  </Typography>
                  <label style={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Expected Income</Typography>
                    <input
                      type="number"
                      value={financeData.expectedIncome}
                      onChange={(e) => {
                        updateFinancialData("expectedIncome", e.target.value);
                      }}
                    />
                  </label>
                </Box>
                <Box>
                  <label style={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Expected Savings</Typography>
                    <input
                      type="number"
                      value={financeData.expectedSavings}
                      onChange={(e) => {
                        updateFinancialData("expectedSavings", e.target.value);
                      }}
                    />
                  </label>
                </Box>
              </Paper>
              {/* Box 3................................................................................................. */}
              <Paper
                elevation={2}
                sx={{
                  gridColumn: "span 1",
                  p: 2,
                  textAlign: "left",
                }}
              >
                <CardReferenceTag
                  color="green"
                  tooltip="Calculate your daily budget by adding below an average amount of fixed bills / required expenses you still have to pay, this value won't be saved, so just adjust it according to the current expectations. When in doubt, be a pessimist."
                />
                <Box>
                  <Typography sx={{ mt: 1 }} variant="h5">
                    <strong>Daily Budget Calculation</strong>
                  </Typography>
                  <label style={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Expected expenses remaining</Typography>
                    <input
                      value={estimatedMandatoryExpenses}
                      onChange={(e) => {
                        setEstimatedMandatoryExpenses(Number(e.target.value));
                      }}
                    />
                  </label>
                  <Typography sx={{ mt: 2 }}>
                    <strong>Today you can spend up to:</strong> ${dailyBudget}{" "}
                  </Typography>
                </Box>
              </Paper>
              {/* Box 4................................................................................................. */}
              <Paper
                elevation={2}
                sx={{
                  gridColumn: "span 2",
                  p: 2,
                  textAlign: "left",
                }}
              >
                <CardReferenceTag
                  color="orange"
                  tooltip="Add Expenses and Extra income"
                />
                <Box>
                  <Typography sx={{ mt: 1 }} variant="h5">
                    <strong>Expenses / Extra Income</strong>
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                    }}
                  >
                    <Box sx={{ flex: "1" }}>
                      <Typography>Add Expense</Typography>
                      <label>
                        <Typography> Amount</Typography>
                        <input
                          id="expenseAmount"
                          type="number"
                          value={newExpense.amount}
                          onChange={(e) =>
                            setNewExpense((prev) => ({
                              ...prev,
                              amount: Number(e.target.value),
                            }))
                          }
                        />
                      </label>
                      <Box>
                        <div>
                          <label>
                            <Typography>Category</Typography>
                            <select
                              value={newExpense.category ?? ""}
                              onChange={(e) =>
                                setNewExpense((prev) => ({
                                  ...prev,
                                  category: e.target.value,
                                }))
                              }
                            >
                              <option key="unselected" value={""}>
                                -Select Category-
                              </option>
                              {defaultCategories.map((category) => (
                                <option key={category} value={category}>
                                  {category}
                                </option>
                              ))}
                            </select>
                          </label>
                        </div>
                        {newExpense.category === "Other" && (
                          <label>
                            <Typography> Custom Category</Typography>
                            <input
                              id="customCategory"
                              value={newExpense.customCategory}
                              onChange={(e) =>
                                setNewExpense((prev) => ({
                                  ...prev,
                                  customCategory: e.target.value,
                                }))
                              }
                            />
                          </label>
                        )}
                        <Button onClick={addExpense}>Add Expense</Button>
                      </Box>
                    </Box>
                    <Box sx={{ flex: "1" }}>
                      <Typography>Add Extra Income</Typography>
                      <div>
                        <div>
                          <label>
                            <Typography>Amount</Typography>
                            <input
                              id="expenseAmount"
                              type="number"
                              value={newExtraIncome.amount}
                              onChange={(e) =>
                                setNewExtraIncome((prev) => ({
                                  ...prev,
                                  amount: Number(e.target.value),
                                }))
                              }
                            />
                          </label>
                        </div>

                        <label>
                          <Typography>Description</Typography>
                          <input
                            id="customCategory"
                            value={newExtraIncome.description}
                            onChange={(e) =>
                              setNewExtraIncome((prev) => ({
                                ...prev,
                                description: e.target.value,
                              }))
                            }
                          />
                        </label>
                      </div>
                      <Button onClick={addExtraIncome}>Add Extra Income</Button>
                    </Box>
                  </Box>
                </Box>
              </Paper>
              {/* Box 5................................................................................................. */}
              <Paper
                elevation={2}
                sx={{
                  gridColumn: "span 2",
                  p: 2,
                  textAlign: "left",
                }}
              >
                <CardReferenceTag
                  color="purple"
                  tooltip="Current Savings Information"
                />
                <Box>
                  <Typography sx={{ mt: 1 }} variant="h5">
                    <strong>Summary</strong>
                  </Typography>

                  <TotalsCards
                    financeData={financeData}
                    updateFinancialData={updateFinancialData}
                    pdfAreaId="pdf-section"
                  />
                </Box>
              </Paper>
            </Box>
            {financeData?.expenses?.length > 0 && (
              <Box>
                <Paper
                  elevation={2}
                  sx={{
                    mt: 2,
                    gridColumn: "span 2",
                    p: 2,
                  }}
                >
                  <ExpenseBreakdown financeData={financeData} /> : <></>
                </Paper>
              </Box>
            )}
          </Box>
        </Box>

        {/* Transaction list */}
        {/*  {financeData.expenses && financeData.extraIncome && (<ReportTransactionsList financeData={financeData} />)^}  */}
        {/* <ExpenseBreakdown financeData={financeData} />
         */}
        {/* <HomeChart
            financeData={financeData}
            updateFinancialData={updateFinancialData}
          />  */}
      </main>

      <MainInfoUpdateModal
        open={editing === "date"}
        closeModal={() => setEditing("")}
        financeData={financeData}
        updateFinancialData={updateFinancialData}
      />
      {editing === "import" && (
        <FinanceDataImportModal
          open={editing === "import"}
          closeModal={() => setEditing("")}
          financeData={financeData}
          setFinanceData={setFinanceData}
        />
      )}
    </>
  );
};

export default Home;
